import CommentSection from './CmmentSection';
import { useLocation } from 'react-router-dom';
import './Ticket.css';
import { useState } from 'react';
import InfoCard from './InfoCard';
import ImagePreviewGallery from './ImagePreviewGallery';
import ImageModal from './ImageModal';
import Autocomplete from '../../Template/components/UI/Autocomplete/Autocomplete';
import { addData } from '../../firebase';

const images = [
  {
    id: 1,
    url: 'https://picsum.photos/200/300',
    name: 'Image 1',
  },
  {
    id: 2,
    url: 'https://picsum.photos/200/301',
    name: 'Image 2',
  },
  {
    id: 3,
    url: 'https://picsum.photos/200/302',
    name: 'Image 3',
  },
  {
    id: 4,
    url: 'https://picsum.photos/800/303',
    name: 'Image 4',
  },
  {
    id: 5,
    url: 'https://picsum.photos/200/304',
    name: 'Image 5',
  },
];

const tipPrijave = [
  {
    id: 1,
    vrednost: 'Novi zahtev',
    boja: '#94bcff',
  },
  {
    id: 2,
    vrednost: 'Korekcija',
    boja: '#ff6358',
  },
];

const statusData = [
  {
    id: 1,
    vrednost: 'Za-izradu',
    boja: '#6c757d',
  },
  {
    id: 2,
    vrednost: 'U-izradi',
    boja: '#fdb813',
  },
  {
    id: 3,
    vrednost: 'Testiranje',
    boja: '#58acce',
  },
  {
    id: 4,
    vrednost: 'Završen',
    boja: '#28a745',
  },
  {
    id: 5,
    vrednost: 'Odbijen',
    boja: '#f31700',
  },
];

function Ticket() {
  const { state } = useLocation(); // todo: upunjavati apijem slanjem id-a tiketa i iz grda i iz notifikacije
  // console.log(state);
  const [selectedImg, setSelectedImg] = useState(null);
  const [formData, setFormData] = useState({
    id: 0,
    idTipa: 0, // proslediti ove id-eve iz grida
    tip: state.tipPrijave || '',
    bojaTipa: state.bojaPrijave || '',
    idStatusa: 0, // proslediti ove id-eve iz grida
    status: state.status,
    bojaStatusa: state.boja,
    komentar: '',
  });

  const handlePosaljiKomentar = () => {
    // console.log('slanje komentara');

    addData({
      title: 'Komentar',
      body: `${localStorage.korisnik} je komentarisao/la tiket broj #${state.brojTiketa}`,
      timestamp: new Date(),
      userId:
        state.idKorisnikaPrijave === +localStorage.idKorisnika
          ? 2318
          : state.idKorisnikaPrijave, // ako je ulogovani korisnik onaj koji je prijavio problem, onda se notifikacija salje Okti
      read: false,
      idTiketa: state.id,
    });
  };

  const handleChange = (e) => {
    const newFormData = {
      ...formData,
      [e.target.name]: e.target.value,
    };
    setFormData(newFormData);
  };

  const handleClickTipPrijave = (e) => {
    const newFormData = {
      ...formData,
      idTipa: e.id,
      tip: e.vrednost,
      bojaTipa: e.boja,
    };
    setFormData(newFormData);
  };

  const handleClickStatus = (e) => {
    const newFormData = {
      ...formData,
      idStatusa: e.id,
      status: e.vrednost,
      bojaStatusa: e.boja,
    };
    setFormData(newFormData);
  };

  const handleEditComment = (comment) => {
    const newFormData = {
      ...formData,
      komentar: comment.text,
    };
    setFormData(newFormData);
  };

  return (
    <div style={{ padding: '10px' }}>
      <div className="title_panel" style={{ justifyContent: 'center' }}>
        <span className="title">
          <span> DETALJI PRIJAVE </span>
        </span>
      </div>
      <div className="snippets" />
      <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <div>
          <label
            style={{
              fontSize: '16px',
              marginLeft: '10px',
              fontWeight: 'bold',
            }}
          >
            Osnovne informacije
          </label>
          <InfoCard
            number={state.brojTiketa}
            title={state.naslov}
            date={state.datumPrijave}
            comment={state.opis}
            user={state.korisnik}
            priority={state.prioritet}
            status={state.status}
          />
          <label
            style={{
              fontSize: '16px',
              marginLeft: '10px',
              fontWeight: 'bold',
            }}
          >
            Priloženi fajlovi
          </label>
          <ImagePreviewGallery
            images={images}
            setSelectedImg={setSelectedImg}
          />
          {selectedImg && (
            <ImageModal
              selectedImg={selectedImg}
              setSelectedImg={setSelectedImg}
            />
          )}
        </div>
        <div>
          {/* //todo: za korisnika OKTA se prikazuje ovo, dodeliti mu neki fleg (SA) pa po njemu ispitivati ne po id-u */}
          {+localStorage.idKorisnika === 2318 && (
            <div style={{ display: 'flex' }}>
              <div className="control" style={{ display: 'grid' }}>
                <label htmlFor="tipProblema">Tip prijave:</label>
                <Autocomplete
                  id="tipProblema"
                  data={tipPrijave}
                  style={{
                    flex: 3,
                    font: 'inherit',
                    padding: '0.35rem 0.35rem',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                    height: '33px',
                  }}
                  handleClick={(e) => handleClickTipPrijave(e)}
                  value={formData.tip}
                />
              </div>
              <div className="control" style={{ display: 'grid' }}>
                <label htmlFor="status">Status:</label>
                <Autocomplete
                  id="status"
                  data={statusData}
                  style={{
                    flex: 3,
                    font: 'inherit',
                    padding: '0.35rem 0.35rem',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                    height: '33px',
                  }}
                  handleClick={(e) => handleClickStatus(e)}
                  value={formData.status}
                />
              </div>
            </div>
          )}
          <div
            style={{
              display: 'flex',
              marginTop: +localStorage.idKorisnika === 2318 && '-20px',
            }}
          >
            <div className="control" style={{ display: 'grid' }}>
              <label htmlFor="komentar">Komentar:</label>
              <input
                type="text"
                id="komentar"
                autoComplete="off"
                name="komentar"
                value={formData.komentar}
                onChange={handleChange}
                style={{ width: '590px' }}
              />
            </div>
            <button
              className="modal-button"
              style={{
                borderColor: 'transparent',
                backgroundColor: '#00afef',
                height: '30px',
                marginTop: '46px',
                width: '120px',
              }}
              onClick={handlePosaljiKomentar}
            >
              Pošalji
            </button>
          </div>
          <div className="snippets" />
          <div style={{ width: '730px' }}>
            <CommentSection handleEditComment={handleEditComment} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ticket;
